import { defineRouting } from "next-intl/routing";

export const locales = ["sv", "en"] as const;
export type AppLocale = (typeof locales)[number];

export const publicPathnames = [
  "/",
  "/configure",
  "/articles",
  "/privacy",
  "/terms",
  "/delivery",
  "/contact",
  "/care-homes",
  "/preschool",
  "/name-stickers",
  "/clothes",
] as const;

export const pathnames = {
  "/": "/",
  "/configure": {
    sv: "/konfigurera",
    en: "/configure",
  },
  "/articles": {
    sv: "/artiklar",
    en: "/articles",
  },
  "/articles/[slug]": {
    sv: "/artiklar/[slug]",
    en: "/articles/[slug]",
  },
  "/articles/tag/[tag]": {
    sv: "/artiklar/tag/[tag]",
    en: "/articles/tag/[tag]",
  },
  "/articles/preview/[slug]": {
    sv: "/artiklar/preview/[slug]",
    en: "/articles/preview/[slug]",
  },
  "/cart": {
    sv: "/varukorg",
    en: "/cart",
  },
  "/thank-you": {
    sv: "/tack",
    en: "/thank-you",
  },
  "/privacy": {
    sv: "/integritetspolicy",
    en: "/privacy",
  },
  "/terms": {
    sv: "/villkor",
    en: "/terms",
  },
  "/delivery": {
    sv: "/leverans",
    en: "/delivery",
  },
  "/contact": {
    sv: "/kontakt",
    en: "/contact",
  },
  // SEO landing page for the adult / group-living segment (task 167). The SV
  // slug carries the lead keyword; keep it stable — it is the ads final URL.
  "/care-homes": {
    sv: "/namnlappar-aldreboende",
    en: "/name-labels-care-homes",
  },
  // SEO landing page for `namnlappar förskola` (commercial SERP, see
  // docs/seo/keyword-baseline.md). Keep the SV slug stable.
  "/preschool": {
    sv: "/namnlappar-forskola",
    en: "/name-labels-preschool",
  },
  // SEO landing page for the hard-surface cluster `klistermärken med namn`.
  "/name-stickers": {
    sv: "/klistermarken-med-namn",
    en: "/name-stickers",
  },
  // SEO landing page; keep the SV slug stable (see clothes/page.tsx).
  "/clothes": {
    sv: "/namnlappar-klader",
    en: "/name-labels-clothes",
  },
  // Keep the developer/reference page stable because it is intentionally noindex.
  "/design": "/design",
} as const;

export type AppPathname = keyof typeof pathnames;

export const routing = defineRouting({
  locales,
  defaultLocale: "sv",
  localePrefix: "as-needed",
  // Swedish-first brand: `/` is always SV regardless of the visitor's
  // Accept-Language. Without this, next-intl auto-redirects English-language
  // browsers (and English-default crawlers like SEObility, Googlebot) from
  // `/` to `/en/`, which both fragments SV-first ranking signals and made
  // SEObility crawl only the English page graph.
  localeDetection: false,
  // No hreflang `Link` header — it advertised 404s; see docs/seo.md.
  alternateLinks: false,
  pathnames,
});
